import { Controller } from "@hotwired/stimulus"

// Simple collapse toggle without Bootstrap dependency
// Connects to data-controller="collapse-toggle"
export default class extends Controller {
  static targets = ["content", "chevron"]

  toggle() {
    const isOpen = this.contentTarget.style.display !== "none"
    this.contentTarget.style.display = isOpen ? "none" : "block"
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = isOpen ? "" : "rotate(180deg)"
    }
  }
}
